import { atom } from 'jotai'
import { UserId } from 'sierra-domain/api/uuid'

export type SlidingScaleResponseData = { id: string; position: number; uuid?: UserId }
export type SlidingScaleData = {
  responses: SlidingScaleResponseData[]
  totalResponses: number
}
export const currentSlidingScaleDataAtom = atom<SlidingScaleData | undefined>(undefined)
